const EnvironmentBanner = () => {
  // Determine environment
  const environment = import.meta.env.VITE_ENVIRONMENT || 'development';
  const isProduction = environment === 'production';

  // Don't show banner in production
  if (isProduction) {
    return null;
  }

  // Style based on environment
  const bgColor = environment === 'development' ? 'bg-blue-600' : 'bg-amber-500';

  return (
    <div
      className={`fixed right-0 z-[9999] ${bgColor} text-white px-2 py-3 rounded-tl-md rounded-bl-md shadow-md font-medium`}
      style={{
        writingMode: 'vertical-lr',
        textOrientation: 'mixed',
        top: '80px',
      }}
    >
      {environment.toUpperCase()} ENVIRONMENT
    </div>
  );
};

export default EnvironmentBanner;
